import { render } from "./DialogInput.vue?vue&type=template&id=0c184334&scoped=true"
import script from "./DialogInput.vue?vue&type=script&lang=js"
export * from "./DialogInput.vue?vue&type=script&lang=js"

import "./DialogInput.vue?vue&type=style&index=0&id=0c184334&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c184334"]])

export default __exports__